import * as r from 'ramda';

import { UI } from './constants';

const getUiState = r.prop('ui');

const createValueSelector = (name, defaultValue) =>
  r.pipe(getUiState, r.propOr(defaultValue, name));

const createBooleanSelector = (name) => r.pipe(getUiState, r.prop(name), Boolean);

export const getValue = (name) => r.pipe(getUiState, r.prop(name));

export const getAuthIsLoading = createBooleanSelector(UI.Auth.IsLoading);

export const getDatasetsIsFetching = createBooleanSelector(UI.Datasets.IsFetching);

export const getDatasetIsCreating = createBooleanSelector(UI.Datasets.IsCreating);

export const getDatasetIsUpdating = createValueSelector(UI.Datasets.IsUpdating, null);

export const getDatasetsIsCreateDialogVisible = createBooleanSelector(
  UI.Datasets.CreateDialogVisible
);

export const getDatasetsIsUpdateDialogVisible = createBooleanSelector(
  UI.Datasets.UpdateDialogVisible
);

export const getIsProfileDialogVisible = createBooleanSelector(UI.UserProfile.DialogVisible);

export const getIsProfileCreating = createBooleanSelector(UI.UserProfile.IsProfileCreating);

export const getIsProfileUpdating = createBooleanSelector(UI.UserProfile.IsProfileUpdating);

export const getIsCoverPhotoUploading = createBooleanSelector(UI.UserProfile.IsCoverPhotoUploading);

export const getIsProfilePhotoUploading = createBooleanSelector(
  UI.UserProfile.IsProfilePhotoUploading
);

export const getIsWidgetsSettingsUpdating = createBooleanSelector(
  UI.UserProfile.IsWidgetsSettingsUpdating
);

export const getArtsetsIsFetching = createBooleanSelector(UI.Artsets.IsFetching);

export const getIsArtsetCreating = createBooleanSelector(UI.Artsets.IsCreating);

export const getIsArtsetUpdating = createBooleanSelector(UI.Artsets.IsUpdating);

export const getIsArtsetPublishing = createBooleanSelector(UI.Artsets.IsPublishing);

export const getIsArtsetUnpublishing = createBooleanSelector(UI.Artsets.IsUnpublishing);

export const getArtsetAddingImages = createValueSelector(UI.Artsets.AddingImages, []);
